__webpack_require__.p = "/hexagonal-architecture/";